import { escapeHtml } from "./html";

/** Renders the expandable help card shown beneath the writer steps. */
export function renderWriterHelpView(showHelp: boolean, writeSupportDetail: string): string {
  if (!showHelp) {
    return "";
  }

  return `
    <section class="panel writer-help-card">
      <h2 class="writer-help-title">Help</h2>
      <p class="writer-help-copy">
        SPOT Writer allows you to update the configuration of your SPOT receiver
        based on a SPOT configuration file. You may have received this file from
        your organization, or generated it yourself in SPOT Editor. The file
        will have the extension <code>.json</code>.
      </p>
      <p class="writer-help-copy">
        Follow these steps to write the configuration file to your receiver:
      </p>
      <ul>
        <li class="writer-help-copy">
          Begin by connecting your receiver to your computer with a USB data
          cable. Although the receiver has a USB-C connector, you must use a cable
          with a USB-A connector on the computer side. For more details, see the
          SPOT Editor manual.
        </li>
        <li>
          Power on the receiver and wait for it to start.
        </li>
        <li>
          Load a SPOT <code>.json</code>
          file and choose <strong>Write to Receiver</strong>. SPOT Writer will
          connect to your receiver over the USB cable.
          <ul>
            <li>
              You may have lots of things connected to your computer via USB, so the
              first time you use SPOT Writer, it will ask which of those is your
              receiver. Select the item that begins with SPOT Receiver, then hit Continue.
              <a class="writer-help-port-selector" href="/documents/spot_editor/manual/images/PortSelector.png" target="_blank" rel="noopener noreferrer">
                <img src="/documents/spot_editor/manual/images/PortSelector.png" alt="Browser port selector showing SPOT Receiver" />
              </a>
            </li>
            <li>
              In the future, SPOT Writer will try to find the port automatically so you don't have to do this again.
            </li>
          </ul>
        </li>
        <li>
          After the write completes, the receiver will restart. This is expected.
          During that restart, the receiver validates the newly written data
          and it may be unresponsive for a short time. Please wait for the
          normal startup screen and do not power the receiver off during that
          process.
        </li>
      </ul>
      <p class="writer-help-copy">
        After the write completes, the receiver will restart. This is expected.
        During that restart, the receiver validates the newly written data
        and it may be unresponsive for a short time. Please wait for the
        normal startup screen and do not power the receiver off during that
        process.
      </p>
      <p class="writer-help-copy">
        NOTE: Writing overwrites the programming currently stored in the receiver,
        including channels, lists, and receiver-wide settings contained in the
        JSON file. It does not edit or merge what is already there.
      </p>
      ${
        writeSupportDetail
          ? `<section class="writer-help-support-detail">
              <h3>Technical Information for Support</h3>
              <p class="writer-help-copy">If support asks, report this message:</p>
              <code>${escapeHtml(writeSupportDetail)}</code>
            </section>`
          : ""
      }
      <div class="writer-help-actions">
        <button type="button" id="help-close-btn">Close</button>
      </div>
    </section>
  `;
}
